import {BsPlayCircle} from "react-icons/bs";
import "./playbtnVideo.css"

export const PlaybtnVideo = () => {
    return <div >
        <BsPlayCircle id="btn1"/>
    </div>
}